import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { ApiRequest } from "src/app/_models";
import { EmailModel } from "src/app/_models/common/EmailModel";
import { environment } from "src/environments/environment";
import { AuthenticationService } from "src/app/_services";
import { EmailService } from "src/app/_services/common/email.service";
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Subscription } from "rxjs";
import { Claims } from "src/app/_models/common/claims";
import { ClaimsService } from "src/app/_services/common/claims.service";

@Component({
  selector: "app-mfa-popup",
  templateUrl: "./mfa-popup.component.html",
  styleUrls: ["./mfa-popup.component.scss"],
  standalone: true,
  imports: [TranslateModule,
    CommonModule,
    FormsModule
  ],
})
export class MfaPopupComponent implements OnInit {
  @Input() username: string = ""; // email string passed from parent
  @Input() param: any;
  @Output() continue = new EventEmitter<void>();
  @Output() signup = new EventEmitter<void>();

  claims: Claims;
  claimsSubscription: Subscription;
  // MFA/OTP state
  showMailOTPBox = false;
  showAuthenticatorBox = false;
  userLoginResponse: any;
  isOTPModelOpen = false;
  isMFADeviceRewgistered = false;

  interval: any;
  isInvalidOTP = false;
  otp1: any;
  otp2: any;
  otp3: any;
  otp4: any;
  otp5: any;
  otp6: any;
  OTP: any;
  isValidOTPEntered = false;
  myColorVaraible: string = "black";
  mybgColorVaraible: string = "white";
  showGetCodeInput = false;

  // QR / registration
  @Input() qrSecret: string = "";
  qrCodeUrl: string = "";
  qrToken: string = "";

  constructor(
    private authenticationService: AuthenticationService,
    private toastr: ToastrService,
    private claimsService: ClaimsService,
    private emailService: EmailService
  ) {
     this.claimsSubscription = this.claimsService.currentClaims.subscribe((claims) => {
            this.claims = claims;
        });
  }

  ngOnInit(): void {}

  validateOTP() {
    if (
      this.otp1?.toString().toString().length > 0 &&
      this.otp2?.toString().toString().length > 0 &&
      this.otp3?.toString().toString().length > 0 &&
      this.otp4?.toString().toString().length > 0 &&
      this.otp5?.toString().toString().length > 0 &&
      this.otp6?.toString().toString().length > 0
    ) {
      if (
        this.OTP.toString() ==
        this.otp1.toString() +
          this.otp2.toString() +
          this.otp3.toString() +
          this.otp4.toString() +
          this.otp5.toString() +
          this.otp6.toString()
      ) {
        this.mybgColorVaraible = "green";
        this.myColorVaraible = "white";
        this.isValidOTPEntered = true;
        this.showGetCodeInput = false;
        this.isInvalidOTP = false;
        clearInterval(this.interval);
      } else {
        this.mybgColorVaraible = "red";
        this.myColorVaraible = "white";
        this.isValidOTPEntered = false;
        this.isInvalidOTP = true;
      }
    } else {
      this.mybgColorVaraible = "white";
      this.myColorVaraible = "black";
      this.isValidOTPEntered = false;
      this.isInvalidOTP = false;
    }
  }

  onDigitInput(event: any) {
    let element;
    if (event.code !== "Backspace") element = event.srcElement.nextElementSibling;

    if (event.code === "Backspace") element = event.srcElement.previousElementSibling;

    if (element == null) return;
    else element.focus();
  }

  handleMFAResponse(loginResponse: any) {
    // called by parent when login response indicates MFA
    this.userLoginResponse = loginResponse;
    if (loginResponse.responseInfo.isMFAEnabled) {
      if (loginResponse.responseInfo.isMFADeviceRegistered) {
        this.isMFADeviceRewgistered = true;
        this.showAuthenticatorBox = true;
        this.showMailOTPBox = false;
        this.qrSecret = loginResponse.responseInfo.mfaSecret;
        // open modal via DOM trigger (keeps markup same as before)
        setTimeout(() => {
          const el = document.getElementById("openModalButton") as HTMLButtonElement;
          if (el) el.click();
        }, 0);
        this.isOTPModelOpen = true;
      } else {
        this.isMFADeviceRewgistered = false;
        this.registerMFADevice();
      }

      this.otp1 = this.otp2 = this.otp3 = this.otp4 = this.otp5 = this.otp6 = undefined;
    }
  }

  verifyToken(): void {
    this.qrToken =
      this.otp1.toString() +
      this.otp2.toString() +
      this.otp3.toString() +
      this.otp4.toString() +
      this.otp5.toString() +
      this.otp6.toString();

    let request = new ApiRequest<any>("verifyTotp", environment.applicationVersion, environment.requestId);
    request.requestInfo = {
      token: this.qrToken,
      secret: this.qrSecret,
      emailId: this.username
    };

  this.authenticationService.verifyTotp(request).subscribe((response: any) => {
    if (response.responseInfo.verified) {
        const closeBtn = document.getElementById("closeOTPModel") as HTMLButtonElement;
        if (closeBtn) closeBtn.click();
        // signal parent to continue login
        this.continue.emit();
      } else {
        this.toastr.error("Invalid Code");
      }
    });
  }

  resendOTP() {
    let em = new EmailModel();
    em.to = this.username;
    em.templateName = "OnboardingOTP";
    em.userId = 0;
    em.subjct = "OTP";
    em.sentTime = 0;
    em.deliveredTime = 0;
    em.status = 1;
    em.emailLogId = this.newGuid();
    var otp = Math.floor(100000 + Math.random() * 900000);
    em.keyValuePairs["OTP"] = otp.toString();

    let req = new ApiRequest<EmailModel>("", 1, "");
    req.requestInfo = em;
    this.emailService.SendEmail(req).subscribe(() => {
      this.OTP = otp;
      this.showAuthenticatorBox = false;
      this.showMailOTPBox = true;
      this.showGetCodeInput = false;
      if (!this.isOTPModelOpen) {
        const openBtn = document.getElementById("openModalButton") as HTMLButtonElement;
        if (openBtn) openBtn.click();
        this.isOTPModelOpen = false;
      }
    });
  }

  newGuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  verifyOTPandLogin() {
    // simply emit continue so parent can perform the final login continuation
    this.continue.emit();
  }

  continueLoginFromRegistration() {
    this.continue.emit();
  }

  continueLoginCallback() {
    this.continue.emit();
  }

  continueLogin() {
    this.continue.emit();
  }

  continueLoginEvent() {
    this.continue.emit();
  }

  continueLoginSignal() {
    this.continue.emit();
  }

  continueMade() {
    this.continue.emit();
  }

  continueRequested() {
    this.continue.emit();
  }

  continueNow() {
    this.continue.emit();
  }

  verifyMFARegistrationToken(): void {
    let request = new ApiRequest<any>("verifyTotp", environment.applicationVersion, environment.requestId);
    request.requestInfo = {
      token: this.qrToken,
      secret: this.qrSecret,
      emailId: this.username,
    };

    this.authenticationService.verifyTotp(request).subscribe((response) => {
      if (response.responseInfo.verified) {
        this.toastr.success("Success");
        if (this.userLoginResponse && this.userLoginResponse.responseInfo)
          this.userLoginResponse.responseInfo.isMFADeviceRegistered = true;
        const closeEl = document.getElementById("closeMFARegistrationModel") as HTMLButtonElement;
        if (closeEl) closeEl.click();
        // notify parent to continue login
        this.continue.emit();
      } else {
        this.toastr.error("Invalid token");
      }
    });
  }

  fnShowAuthenticatorBox() {
    if (!this.isMFADeviceRewgistered) {
      this.openMFARegistration();
    } else {
      this.showAuthenticatorBox = true;
      this.showMailOTPBox = false;
    }
  }

  registerMFADevice() {
    let request = new ApiRequest<any>("verifyTotp", environment.applicationVersion, environment.requestId);
    request.requestInfo = {
      emailId: this.username,
    };

    this.authenticationService.getTotpSetup(request).subscribe((data: any) => {
      this.qrCodeUrl = data.responseInfo.qrCodeUrl;
      this.qrSecret = data.responseInfo.secret;
      const el = document.getElementById("openMFAOptionButton") as HTMLButtonElement;
      if (el) el.click();
    });
  }

  openMFARegistration() {
    // First check if QR code is already loaded
    if (!this.qrCodeUrl) {
      // Fetch QR code first, then open the modal
      let request = new ApiRequest<any>("verifyTotp", environment.applicationVersion, environment.requestId);
      request.requestInfo = {
        emailId: this.username,
      };

      this.authenticationService.getTotpSetup(request).subscribe((data: any) => {
        this.qrCodeUrl = data.responseInfo.qrCodeUrl;
        this.qrSecret = data.responseInfo.secret;
        // Now open the registration modal
        const el = document.getElementById("openMFARegistrationButton") as HTMLButtonElement;
        if (el) el.click();
      });
    } else {
      // QR code already loaded, just open modal
      const el = document.getElementById("openMFARegistrationButton") as HTMLButtonElement;
      if (el) el.click();
    }
  }
}
